import Observer from "./observer.js";
import { CreateIFrameDocument } from "../../messages/index.js";
export default class ShadowRootObserver extends Observer {
    observe(el) {
        const shRoot = el.shadowRoot;
        const hostID = this.app.nodes.getID(el);
        if (!shRoot || hostID === undefined) {
            return;
        } // log
        this.observeRoot(shRoot, (rootID) => {
            if (rootID === undefined) {
                console.log("OpenReplay: Shadow Root was not bound");
                return;
            }
            this.app.send(CreateIFrameDocument(hostID, rootID));
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@openreplay/tracker/lib/app/observer/shadow_root_observer.js
// module id = 2643
// module chunks = 0